import { formatMessage } from "lib/globalize-util";
import { MerchantOption } from "../types/merchants";

export const DEFAULT_FONT_FAMILY = "Lato, sans-serif";
export const DEFAULT_FONT_WEIGHT = "normal";
export const DEFAULT_FONT_SIZE = 14;
export const DEFAULT_ICON_SIZE = 20;

export const DIALOG_MIN_HEIGHT = 300;
export const DIALOG_HEADER_HEIGHT = 56;
export const MANAGE_ACCESS_LIST_ROW_MAX_HEIGHT = 48;
export const MANAGE_ACCESS_PICKER_INPUT_MIN_HEIGHT = 36;
export const MODAL_BACKGROUND_HEIGHT = 510;
export const COIN_SIZE = 36;
export const MANAGE_ACCESS_DIALOG_HEIGHT = 600;
export const ITEM_SHARED_LIST_MAX_HEIGHT = 325;
export const MANAGE_ACCESS_FOOTER_MAX_HEIGHT = 192;
export const MANAGE_ACCESS_INPUT_BOX_MAX_WIDTH = 358;
export const MANAGE_ACCESS_COMFIRM_BOX_MAX_WIDTH = 166;
export const MANAGE_ACCESS_DIALOG_MAX_WIDTH = 600;
export const PERMISSION_NAME_COLUMN_MIN_WIDTH = 40;
export const ASSORTMENT_PERMISSION_NAME_COLUMN_MAX_WIDTH = 320;
export const GLOBAL_TOP_BAR_HEIGHT = 60;
export const DROPDOWN_WIDTH = 120;
export const DROPDOWN_INPUT_WIDTH = 100;
export const ASSORTMENT_DROPDOWN_WIDTH = 168;
export const BRAND_DROPDOWN_MAXWIDTH = 262;
export const ASSORTMENT_PERSONA_CARD_WIDTH = 250;
export const PERSONA_CARD_WIDTH = 192;
export const PERMISSIONS = "permissions";
export const MY_DRIVE = "My Drive";
export const DRIVE_LINK = "/drive";
export const SHARED_WITH_ME_ROOT_ITEM_ID = "<UNKOWN>";
export const MAX_LINEAGE_NODE = "...";
export const MAX_LINEAGE_CALLS = 10;
export const ITEM_CREATION_RETRIES = 3;
export const MIN_RETRY_FOR_CREATE_MANUAL_SHORTCUT = 2;
export const pathToRootDrive = (merchantId) => `${DRIVE_LINK}?itemId=root&merchantId=${merchantId}`;
export const KEY_DOT = 190;
export const MAX_ASSETS_SELECTED_TO_MOVE = 1000;
export const MAX_ASSORTMENTS_SELECTED = 400;
export const _DOT_ROLL = ".roll";
export const ROOT_LEVEL = "__root__";
export const ROLLUP_SNAPSHOT_FOLDER = ".rollupsnapshots";
export const LAST_SORT_FIELD = "drive-items-last-sort-field";
export const LAST_SORT_DIRECTION = "drive-items-last-sort-direction";
export const defaultEmptyValue = "--";
export const STARRED_ITEM_FEATURE = true;
export const SERVER_ROLLUP_REFECTCH_INTERNAL = 5000;
export const MAX_WHITEBOARDS_SELECTED = 40;
export const MAX_FAILURE_COUNT = 3;
export const NUORDER = "(NuORDER)";

export enum ErrorCodes {
    ALREADY_EXISTS_ITEM_WITH_SAME_NAME = 6,
}

export enum TabValues {
    Internally = "internally",
    Brands = "brands",
    Buyers = "buyers",
}

export const getDefaultMerchantOption = (): MerchantOption => ({ value: "", label: formatMessage("All merchants") });
